<template>
  <div class="ui fluid image">
    <div
      class="ui image rectangular"
      :class="size"
      :style="{ backgroundImage: `url(${ image })`}"
    >
      <button class="ui button mobile hidden" @click="$emit('play')">
        <i class="ui bzl-play massive icon playButton"></i>
      </button>
      <button class="ui button mobile only" @click="$emit('play')">
        <i class="ui bzl-play huge icon playButton"></i>
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Thumbnail',
  props: ['syncguid', 'size'],
  computed: {
    image() {
      return this.$store.getters.contentById(this.syncguid).thumbnail || null;
    },
  },
};
</script>

<style lang="less" scoped>
.ui.button {
  color: rgba(255,255,255,.6);
  background: transparent;
  & :hover {
    color: rgba(255,255,255);
  }
}
</style>
